import {ChangeDetectionStrategy, Component} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {PlainDateDateAdapter} from "../../../../felles-ng2/infrastruktur/material/PlainDateDateAdapter";

const debug = initDebugger('MatDatoformatKomponent');

/**
 * Skriver ut datoformat som {@link PlainDateDateAdapter} benytter.
 */
@Component({
    selector: 'mat-datoformat',
    template: '{{matDatoAdapter.localeSensitivtParseFormat().toLowerCase()}}',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatDatoformatKomponent {
    constructor(public matDatoAdapter: PlainDateDateAdapter) {
    }
}
